import React from 'react';

import SVGIcon, { BASE_ICONS } from 'src/components/svg';

import { lang, scssVariables } from 'src/helpers';

const Steps = React.memo(({ list = [], current = null, screenDetail = {} }) => {
  let hasCurrent = false;

  const vertical = screenDetail.isSmallScreen;

  const active = list.find((s) => s.name === current);

  return (
    <>
      {vertical && (
        <div className={'mc-steps-header'}>
          <div className='title'>{lang.t(active.title)}</div>
          <div className='caption'>{lang.t(active.description)}</div>
        </div>
      )}
      <div className={`mc-steps ${vertical ? 'vertical' : ''}`}>
        {vertical && <div className={'mc-steps-line'} />}
        {list.map((item, i) => {
          if (item.name === current) hasCurrent = true;
          return (
            <div
              className={
                'step' + (item.name === current ? ' step-active' : !hasCurrent ? ' step-done' : '')
              }
              key={i}
            >
              {!vertical && (
                <div className={'content'}>
                  <div className='title'>{lang.t(item.title)}</div>
                  <div className='caption'>{lang.t(item.description)}</div>
                </div>
              )}
              <div className={'circle'}>
                <div className={'circle-icon'}>
                  {!hasCurrent ? (
                    <SVGIcon
                      circle
                      outline
                      padding={5}
                      iconname={BASE_ICONS.CHECK}
                      width={42}
                      fill={scssVariables['colors-mc-primary']}
                    />
                  ) : (
                    <span>{i + 1}</span>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
});
Steps.displayName = 'Steps';

export default Steps;
